import { render, staticRenderFns } from "./OrganizerOrdersList.vue?vue&type=template&id=0d27fdf0&"
import script from "./OrganizerOrdersList.vue?vue&type=script&lang=js&"
export * from "./OrganizerOrdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports